import React, {useEffect, useRef} from "react";
import { useIsAuthenticated , useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import { InteractionStatus } from "@azure/msal-browser";


function handleLogin(instance) {
    console.log("handle login ");
    instance.loginRedirect(loginRequest).catch(e => {
        console.error("login error msg",e);
    });
}
export const PageLayout = (props) => {
    const isAuthenticated = useIsAuthenticated();
    const { instance,inProgress } = useMsal();
    const loginCalled = React.useRef(false);
    const loggedOnce = React.useRef(false);

    useEffect(() => {
        if (!isAuthenticated && inProgress === InteractionStatus.None && !loginCalled.current)
        {
            loginCalled.current = true; 
            handleLogin(instance);            
        }else if (isAuthenticated && !loggedOnce.current) {
        loggedOnce.current = true;
        console.log("authenticated");
    }
      },[inProgress, instance, isAuthenticated])

    return (
        <>
            {
                isAuthenticated ? props.children : 
                <div style={{margin: '20px 0 0 10px',fontSize: '20px',fontStyle: 'italic',fontWeight: 'bold'}}>
                    Checking Authentication...
                </div>
            }                
        </>
    );
};